import React from "react"
import styled from "styled-components"
// Components
import FullButton from "../Buttons/FullButton"
// Assets
import SendingEmailImg from "../../assets/img/sending-email.jpg"

export default function Contact() {
  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
            <p className="font13">
              Complete the form below with a description of your project and
              considerations.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form id="contactus" act>
                <label className="font13">Name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="font20 extraBold"
                />
                <label className="font13">Email:</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="font20 extraBold"
                />
                <label className="font13">Subject:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="font20 extraBold"
                />
                <textarea
                  rows="4"
                  cols="50"
                  type="text"
                  id="message"
                  name="message"
                  className="font20 extraBold"
                />
              </Form>
              <SubmitWrapper className="flex">
                <div style={{ width: "190px" }}>
                  <FullButton
                    title="Submit"
                    action={() =>
                      (window.location.href =
                        "mailto:info@boditel.com?" +
                        "cc=" +
                        document.getElementById("email").value +
                        "&subject=" +
                        "Contact Us [" +
                        document.getElementById("name").value +
                        "] - " +
                        document.getElementById("subject").value +
                        "&body=" +
                        document.getElementById("message").value)
                    }
                  />
                </div>
              </SubmitWrapper>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 flex">
              <ImageWrapper>
                <Img
                  className="radius8"
                  src={SendingEmailImg}
                  height={500}
                  width={500}
                  alt="email"
                  style={{ zIndex: 9 }}
                />
              </ImageWrapper>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  width: 100%;
`
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`
const Img = styled.img`
  @media (max-width: 560px) {
    width: 80%;
    height: auto;
  }
`
const SubmitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`
